import { render, staticRenderFns } from "./DeleReported.vue?vue&type=template&id=f6f4da0c&"
import script from "./DeleReported.vue?vue&type=script&lang=js&"
export * from "./DeleReported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports